'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var TextMapPropagator = require('./text_map');

var HttpPropagator =
/*#__PURE__*/
function (_TextMapPropagator) {
  _inherits(HttpPropagator, _TextMapPropagator);

  function HttpPropagator() {
    _classCallCheck(this, HttpPropagator);

    return _possibleConstructorReturn(this, _getPrototypeOf(HttpPropagator).apply(this, arguments));
  }

  return HttpPropagator;
}(TextMapPropagator);

module.exports = HttpPropagator;